import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-item-categories',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, RippleModule],
  templateUrl: './item-categories.component.html',
  styleUrls: ['./item-categories.component.scss'],
})
export class ItemCategoriesComponent {
  constructor(private router: Router) { }


  categories = [
    { label: 'Closing Soon', src: '/bfg_icons_closing_soon.png' },
    { label: 'Dining', src: '/bfg_icons_dining.png' },
    { label: 'Designer', src: '/bfg_icons_designer.png' },
    { label: 'Electronics', src: '/bfg_icons_electronics.png' },
    { label: 'Tickets', src: '/bfg_icons_tickets.png' },
    { label: 'Travel', src: '/bfg_icons_travel.png' },
    { label: 'Unique', src: '/bfg_icons_unique.png' },
    { label: 'Other', src: '/bfg_icons_other.png' }
  ];

  trackByLabel = (_: number, x: { label: string }) => x.label;

  targetRoute: string = '/items';

  private slugify(label: string) {
    if (label === 'Unique') {
      label = 'experiences';
    } else if (label === 'Closing Soon') {
      label = 'closing';
    }
    return label
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')   // collapse non-alphanum to dashes
      .replace(/^-+|-+$/g, '');      // trim leading/trailing dashes
  }

  go(cat: { label: string }) {
    this.router.navigate([this.targetRoute, this.slugify(cat.label)]);
    // e.g. /items/closing-soon
  }
}
